import Immutable from 'immutable';
import { FISCAL_YEAR_FORMATS } from 'javascripts/util/fiscalFormats';

export const TimelineConfig = Immutable.Record(
  {
    barColor: '',
    bookmarkPath: '',
    compactView: false,
    colorBy: [],
    colorByOptionsPath: '',
    colorMappings: Immutable.Map(),
    colorMappingsPath: '',
    endDate: null,
    fiscalMonth: 1,
    fiscalYearFormat: FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST,
    fontSize: 12,
    fromDateColumnName: '',
    headerWidths: Immutable.List(),
    headingTitles: Immutable.List(),
    id: 0,
    milestones: Immutable.List(),
    milestonesShowTitles: false,
    milestonesShowDates: false,
    milestonesShowLines: false,
    showDependencies: false,
    showFloatingLabels: true,
    showHeadings: false,
    showProgress: false,
    startDate: null,
    theme: 'default',
    themeTableBorder: '',
    themeHeadingsBackground: '',
    themeRowHeaderBackground: '',
    themeHeadingsText: '',
    themeHeaderBackground: '',
    themeHeaderText: '',
    themeHeaderCellBorder: '',
    themeCellBackground: '',
    themeCellText: '',
    themeCellBorder: '',
    themeOptions: Immutable.List(),
    thickBars: false,
    timelineType: '',
    toDateColumnName: '',
    viewOnly: false,
    dashboard: false,
    updatedAt: 0,
  },
  'Timeline'
);

export const TimelineData = Immutable.Record(
  {
    data: Immutable.Map(),
    timelineType: '',
    dependencyLinks: [],
    barReferences: {},
  },
  'TimelineData'
);

export const DateRange = Immutable.Record(
  {
    automaticMaxDate: null,
    automaticMinDate: null,
    maxToDate: null,
    minFromDate: null,
    toDate: null,
    fromDate: null,
    maxDate: null,
    minDate: null,
    timeScale: null,
    zoom: null,
  },
  'DateRange'
);
